//@ts-nocheck
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import {
  validatePasscodeRequest,
  validatePasscodeSuccess,
  validatePasscodeFailure,
} from '../reducer/validatePasscodeSlice';
import { fetchValidatePasscode } from '../api'; // Assuming API paths are correct
import { signInSuccess } from '../reducer/userSlice';
import { isWeb } from '../storage';

interface validatePasscodeAction {
  type: typeof validatePasscodeRequest.type;
  payload: any;
}

// Fetch generate code for device saga
export function* fetchValidatePasscodeRequestSaga(
  action: validatePasscodeAction
): Generator<any, void, unknown> {
  try {
    console.log('Device ID for validate passcode saga');
    const validate: any = yield call(
      fetchValidatePasscode,
      'validate_passcode',
      action.payload
    );

    console.log('fetchValidatePasscode', validate);
    // const { statusCode } = validate?.response?.data;
    // If the API response has the validate passcode under `data`, modify the structure accordingly.
    if (
      isWeb &&
      validate?.status === '200' &&
      (validate?.validateCodeResponse?.productName == 'Rogers Corporate' ||
        validate?.validateCodeResponse?.productName == 'RogersCorporate' ||  validate?.validateCodeResponse?.productName?.toLowerCase().includes('corporate'))
    ) {
      yield put(
        validatePasscodeFailure({
          statusCode: 401,
          error: {
            errCode: 'COORP_401_USER_ERROR',
            msg: 'You are trying to sign into the consumer portal. Click here to sign into the corporate user login.',
            statusCode: 401,
          },
        })
      );
      yield put(
        signInFailure({
          statusCode: 401,
          error: {
            errCode: 'COORP_401_USER_ERROR',
            msg: 'You are trying to sign into the consumer portal. Click here to sign into the corporate user login.',
            statusCode: 401,
          },
        })
      );
    } else if (validate?.status === '200') {
      yield put(validatePasscodeSuccess(validate)); // Assuming API response has a `status` field
      const { authenticated, userName, accountId, customerId } =
        validate?.validateCodeResponse;
      const signInData = {
        accountId,
        customerId,
        authenticated,
        data: {
          username: action.payload.username,
          password: action.payload.password,
          deviceId: action.payload.deviceId,
        },
        userName,
      };
      yield delay(2000);
      console.log('signInSuccess', signInData);
      yield put(signInSuccess(signInData));
    } else {
      yield put(validatePasscodeFailure(validate));
    }
  } catch (error: any) {
    console.log('signInSuccess error', error);
    // const errorData = {
    //   status = '500',
    //   title = 'UNKNOWN_ERROR',
    //   detail = 'An unknown error occurred.',
    // } = generateCode?.response?.data;
    // yield put(
    //   validatePasscodeFailure(errorData)
    // );
  }
}

// Watch generate code for device saga
export function* watchValidatePasscodeSaga(): Generator<any, void, unknown> {
  yield takeLatest(
    validatePasscodeRequest.type,
    fetchValidatePasscodeRequestSaga
  );
}
